export { default as AudioPlayer } from './audio-player.component';
